import React from 'react';
import { getDatalakeUserImageUrl } from '../Helpers/DateLakeStorage';

function ProjectSettingFileList({ organizationId, projectId, files, onRemoveClick }) {

    function handleRemoveClick(fileName) {
        onRemoveClick(fileName);
    }

    return (
        <ul className='border list-group'>
            { files.map((fileName, index) => (
                <li className="list-group-item p-3" key={fileName + "-" + index}>
                    <a
                        target="_blank"
                        href={getDatalakeUserImageUrl(organizationId, projectId, fileName)}
                    >
                        {fileName}
                    </a>
                    <span
                        className="float-end pointer"
                        onClick={() => handleRemoveClick(fileName)}
                    >
                        <i className="fal fa-times text-danger" />
                    </span>
                </li>
            ))}
        </ul>
    )
}

export default ProjectSettingFileList;